import React, { useEffect, useState } from "react";
import { childrenPropType, onSelectPropType, selectedIndexPropType } from "../helpers/propTypes";
import UncontrolledTabs from "./UncontrolledTabs";
import { getTabsCount } from "../helpers/count";
var MODE_CONTROLLED = 0;
var MODE_UNCONTROLLED = 1;
var defaultProps = {
  defaultFocus: false,
  focusTabOnClick: true,
  forceRenderTabPanel: false,
  selectedIndex: null,
  defaultIndex: null,
  environment: null,
  disableUpDownKeys: false
};
var getModeFromProps = function getModeFromProps(props) {
  return props.selectedIndex === null ? MODE_UNCONTROLLED : MODE_CONTROLLED;
};
var checkForIllegalModeChange = function checkForIllegalModeChange(props, mode) {
  if (process.env.NODE_ENV !== "production" && mode != undefined && mode !== getModeFromProps(props)) {
    throw new Error("Switching between controlled mode (by using `selectedIndex`) and uncontrolled mode is not supported in `Tabs`.\nFor more information about controlled and uncontrolled mode of react-tabs see https://github.com/reactjs/react-tabs#controlled-vs-uncontrolled-mode.");
  }
};
var Tabs = function Tabs(props) {
  var children = props.children,
    defaultFocus = props.defaultFocus,
    defaultIndex = props.defaultIndex,
    focusTabOnClick = props.focusTabOnClick,
    onSelect = props.onSelect;
  var _useState = useState(defaultFocus),
    focus = _useState[0],
    setFocus = _useState[1];
  var _useState2 = useState(getModeFromProps(props)),
    mode = _useState2[0];
  var _useState3 = useState(mode === MODE_UNCONTROLLED ? defaultIndex || 0 : null),
    selectedIndex = _useState3[0],
    setSelectedIndex = _useState3[1];
  useEffect(function () {
    setFocus(false);
  }, []);
  if (mode === MODE_UNCONTROLLED) {
    var tabsCount = getTabsCount(children);
    useEffect(function () {
      if (selectedIndex != null) {
        var maxTabIndex = Math.max(0, tabsCount - 1);
        setSelectedIndex(Math.min(selectedIndex, maxTabIndex));
      }
    }, [tabsCount]);
  }
  checkForIllegalModeChange(props, mode);
  var handleSelected = function handleSelected(index, last, event) {
    if (typeof onSelect === "function") {
      if (onSelect(index, last, event) === false) return;
    }
    if (focusTabOnClick) {
      setFocus(true);
    }
    if (mode === MODE_UNCONTROLLED) {
      setSelectedIndex(index);
    }
  };
  var subProps = Object.assign({}, props);
  subProps.focus = focus;
  subProps.onSelect = handleSelected;
  if (selectedIndex != null) {
    subProps.selectedIndex = selectedIndex;
  }
  delete subProps.defaultFocus;
  delete subProps.defaultIndex;
  delete subProps.focusTabOnClick;
  return React.createElement(UncontrolledTabs, subProps, children);
};
Tabs.defaultProps = defaultProps;
Tabs.tabsRole = "Tabs";
export default Tabs;